import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Redirect} from 'react-router';
import Validate from '../lib/validate';
import Settings from '../lib/settings';
import * as Actions from '../actions';
import {connect} from 'react-redux'

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      surname: '',
      email: '',
      password: '',
      passwordAgain: '',
      city: '',
      street: '',
      postalCode: '',
      country: '',
      sended: false,
      formMessage: [],
      redirect: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.addFormMessage = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, this.props.menuPosition);
  }

  addWrongInputClass(name) {
    ReactDOM.findDOMNode(this.refs[name]).classList.add(Settings.wrongInput);
  }

  addFormMessage(message) {

    this.setState(prevState => ({
      formMessage: [
        ...prevState.formMessage,
        message
      ]
    }));
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
    ReactDOM.findDOMNode(this.refs[event.target.name]).classList.remove(Settings.wrongInput);
  }

  handleSubmit(event) {
    event.preventDefault();
    let email = this.state.email.trim().toLowerCase();
    let errorCheck = true;

    this.setState({formMessage: []});

    if (this.state.name === "" || this.state.surname === "" || email === "" || this.state.password === "" || this.state.passwordAgain === "" || this.state.city === "" || this.state.street === "" || this.state.postalCode === "" || this.state.country === "") {
      this.addFormMessage("Pro registraci prosím vyplňte všechna pole!");
      errorCheck = false;
    }

    if (this.state.password !== this.state.passwordAgain) {
      this.addFormMessage("Zadaná hesla nesouhlasí.");
      errorCheck = false;
      this.addWrongInputClass("password");
      this.addWrongInputClass("passwordAgain");
    }

    if (this.state.password.length < 6) {
      this.addFormMessage("Heslo musí mít alespoň 6 znaků");
      errorCheck = false;
      this.addWrongInputClass("password");
      this.addWrongInputClass("passwordAgain");
    }

    if (!Validate.user(this.state.name, "name")) {
      this.addFormMessage("Pro registraci prosím vyplňte jméno.");
      errorCheck = false;
      this.addWrongInputClass("name");
    }

    if (!Validate.user(this.state.surname, "surname")) {
      this.addFormMessage("Pro registraci prosím vyplňte příjmení.");
      errorCheck = false;
      this.addWrongInputClass("surname");
    }

    if (!Validate.email(email)) {
      this.addFormMessage("Pro registraci prosím vyplňte validní email.");
      errorCheck = false;
      this.addWrongInputClass("email");
    }

    if (!Validate.user(this.state.city, "city", true)) {
      this.addFormMessage("Pro registraci prosím vyplňte město.");
      errorCheck = false;
      this.addWrongInputClass("city");
    }

    if (!Validate.user(this.state.street, "street", true)) {
      this.addFormMessage("Pro registraci prosím vyplňte ulici.");
      errorCheck = false;
      this.addWrongInputClass("street");
    }

    if (!Validate.user(this.state.postalCode.replace(/\s+/g, ''), "postalCode", true)) {
      this.addFormMessage("Pro registraci prosím vyplňte PŠČ.");
      errorCheck = false;
      this.addWrongInputClass("postalCode");
    }

    if (!Validate.user(this.state.country, "country", true)) {
      this.addFormMessage("Pro registraci prosím vyplňte zemi.");
      errorCheck = false;
      this.addWrongInputClass("country");
    }

    if (!ReactDOM.findDOMNode(this.refs.termsCeckbox).checked) {
      this.addFormMessage("Musíte souhlasit s podmínkami!");
      this.addWrongInputClass("terms");
      errorCheck = false;
    }

    if (errorCheck) {


      let user = {
        name: this.state.name,
        surname: this.state.surname,
        email: email,
        password: this.state.password,
        address: {
          city: this.state.city,
          street: this.state.street,
          postalCode: this.state.postalCode.replace(/\s+/g, ''),
          country: this.state.country
        }
      }

      if (Validate.user(user)) {

        fetch("/api/users", Settings.fetchParams('POST', user)).then(res => {
          if (res.ok) {
            res.json().then(json => {
              if (!json.error) {
                if(this.props.match.params.last) {
                  this.props.dispatch(Actions.loginAction(json.user, Settings.userMenu));
                  this.setState({
                    redirect: this.props.match.params.last
                  });
                } else {
                  ReactDOM.findDOMNode(this.refs.signup).innerHTML = '<div class="registrationSucessful"><div><h2 class="addSuccess">Registrace proběhla úspěšně. Děkujeme.</h2><span>Nyní jste přihlášen/a.</span></div></div>';
                }

              } else if (typeof json.userExists !== "undefined" && json.userExists) {
                alert("Zadaný email je již registrován.");
                this.addFormMessage("Zadaný email je již registrován.");
                this.addWrongInputClass("email");
              } else {
                alert("Chyba při registraci");
              }
            })
          } else {
            alert("Error");
          }
        });

      } else {
        alert("Prosím vyplňte validně údaje.");
      }

    }

  }

  render() {

    const formErrorMessages = this.state.formMessage.map((item, index) => <p key={index}>{item}</p>);

    return this.state.redirect ? <Redirect to={"/" + this.state.redirect}/> : (<div ref="signup">
      <div className="form">
        <h1>
          Registrace:
        </h1>
        <div className="formErrorMessages">
          {formErrorMessages}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col50">
              <div className="formLabel">Jméno</div>
              <div className="formInput"><input ref="name" type="text" value={this.state.name} onChange={this.handleChange} name="name" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Příjmení</div>
              <div className="formInput"><input ref="surname" type="text" value={this.state.surname} onChange={this.handleChange} name="surname" required="required"/></div>
            </div>
          </div>
          <div className="row">
            <div className="col50">
              <div className="formLabel">E-mail</div>
              <div className="formInput"><input ref="email" type="text" value={this.state.email} onChange={this.handleChange} name="email" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Heslo</div>
              <div className="formInput"><input ref="password" type="password" value={this.state.password} onChange={this.handleChange} name="password" required="required"/></div>
            </div>
          </div>
          <div className="row">
            <div className="col50"></div>
            <div className="col50">
              <div className="formLabel">Heslo (kontrola)</div>
              <div className="formInput"><input ref="passwordAgain" type="password" value={this.state.passwordAgain} onChange={this.handleChange} name="passwordAgain" required="required"/></div>
            </div>
          </div>
          <h2>Adresa:</h2>
          <div className="row">
            <div className="col50">
              <div className="formLabel">Město</div>
              <div className="formInput"><input ref="city" type="text" value={this.state.city} onChange={this.handleChange} name="city" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Ulice a číslo popisné/orientační</div>
              <div className="formInput"><input ref="street" type="text" value={this.state.street} onChange={this.handleChange} name="street" required="required"/></div>
            </div>
          </div>
          <div className="row">
            <div className="col50">
              <div className="formLabel">PSČ</div>
              <div className="formInput"><input ref="postalCode" type="text" value={this.state.postalCode} onChange={this.handleChange} name="postalCode" required="required"/></div>
            </div>
            <div className="col50">
              <div className="formLabel">Země</div>
              <div className="formInput"><input ref="country" type="text" value={this.state.country} onChange={this.handleChange} name="country" required="required"/></div>
            </div>
          </div>
          <div className="col100">
            <label ref="terms" className="pointer"><input ref="termsCeckbox" type="checkbox" className="checkbox" onChange={this.handleChange} name="terms"/>
              Souhlasím s obchodními podmínkami</label>
          </div>
          <div className="col100">
            <button type="submit">Registrovat</button>
          </div>
        </form>
      </div>
    </div>);
  }
}
function mapStateToProps(state){
  return {
    auth: state.auth,
    menuPosition: state.menuPosition,
  };
}
export default connect(mapStateToProps)(Signup);



// WEBPACK FOOTER //
// ./src/pages/Signup.js